/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback, useState } from 'react';
import Button from '@atlaskit/button';
import InlineDialog from '@atlaskit/inline-dialog';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { B300, G200, P200, R300, Y200 } from '@atlaskit/theme/colors';
import MessageIcon from '../message-icon';
var rootStyles = null;
var iconColor = {
  connectivity: "_x5v91r2e",
  confirmation: "_x5v91fgg",
  info: "_x5v913wx",
  warning: "_x5v9f6ss",
  error: "_x5v9k8x7"
};

/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */
var InlineMessage = function InlineMessage(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    _ref$secondaryText = _ref.secondaryText,
    secondaryText = _ref$secondaryText === void 0 ? '' : _ref$secondaryText,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'connectivity' : _ref$type,
    appearance = _ref.appearance,
    children = _ref.children,
    testId = _ref.testId,
    iconLabel = _ref.iconLabel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var toggleDialog = useCallback(function () {
    setIsOpen(function (oldState) {
      return !oldState;
    });
  }, [setIsOpen]);
  var onCloseDialog = useCallback(function () {
    return setIsOpen(false);
  }, [setIsOpen]);
  if (!appearance) {
    appearance = type;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax(["_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh01r31 _38q98stv _1o0knqa1 _1yyu1kum", iconColor[appearance]])
  }, /*#__PURE__*/React.createElement(InlineDialog, {
    onClose: onCloseDialog,
    content: children,
    isOpen: isOpen,
    placement: placement,
    testId: testId && "".concat(testId, "--inline-dialog")
  }, /*#__PURE__*/React.createElement(Button, {
    "data-ds--inline-message--button": true,
    appearance: "subtle-link",
    onClick: toggleDialog,
    spacing: "none",
    testId: testId && "".concat(testId, "--button"),
    "aria-expanded": isOpen
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(MessageIcon, {
    isOpen: isOpen,
    appearance: appearance,
    label: iconLabel
  }), /*#__PURE__*/React.createElement(Inline, {
    space: "space.100"
  }, title && /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    testId: testId && "".concat(testId, "--title")
  }, title), secondaryText && /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    color: "color.text.subtlest",
    maxLines: 1,
    testId: testId && "".concat(testId, "--text")
  }, secondaryText))))));
};
export default InlineMessage;